<template>
  <Card :title="$t('pipelines.associate_partners')" containerClass="mb-5">
    <template #cardToolbar>
      <span :style="{color: secondaryColor, fontSize: '18px', fontWeight: '600'}">{{partners.length}}</span>
    </template>
    <div class="row px-10 py-5">
      <ManyAvatar :size="10" :data="partners" v-if="partners.length > 0"/>
      <OutlineButton v-if="pipeline?.status !== 'WON' && pipeline?.status !== 'LOST'" :border="true" btn-class="mb-2" :color="secondaryColor" btn-text="button.associate_partners" @click="closeModal" :is-disabled="!right"/>
      <OutlineButton v-if="(pipeline?.status !== 'WON' && pipeline?.status !== 'LOST') && $can(abilities.CREATE_USER)" :border="false" :color="primaryColor" btn-text="button.new_partner" @click="openCreateUserModal" :is-disabled="!right"/>
    </div>
  </Card>
  <div class="modal fade" id="addUsers" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
        <div class="modal-dialog" role="document">
        <form @submit.prevent="addUsers" class="form">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ $t('pipelines.addUsers') }}</h5>
                <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor" />
                    </svg>
                </span>
                </div>
            </div>
            <div class="modal-body">
              <RequiredText />
              <div class="d-flex flex-column mb-3 fv-row">
                <span class="text-muted mb-2">{{$t('pipelines.select_users_libelle')}}</span>
                <Select2
                    containerClass="mb-2"
                    name="users"
                    :multiple="true"
                    v-model="usersIds"
                    :label="$t('pipelines.select_users')"
                    labelClass="d-flex align-items-center fs-6 fw-bold mb-2"
                    selectClass="form-select form-select-solid kt_select2"
                    :isRequired="true"
                    :placeholderText="$t('pipelines.select_users')"
                >
                    <option v-for="user in getUsersNotFollowers" :key="user.id" :value="user.id">{{user.fullname}}</option>
                </Select2>
              </div>
              <div v-if="partners && partners.length >0 ">
                <h5 class="fw-bold mb-2">{{$t('pipelines.associate_partners')}}</h5>
                <span class="text-muted mb-5">{{$t('pipelines.associate_partners_text')}}</span>
                <div class="scroll h-300px">
                  <a v-for="user in partners" :key="user.id" class="d-flex align-items-center p-3 rounded bg-state-light bg-state-opacity-50 mb-1">
                    <div :class="'symbol-35px me-2'" class="symbol symbol-circle">
                      <span class="symbol-label fw-bolder" style="background-color: rgba(0, 114, 206, 0.25); color: rgba(0, 114, 206, 1);">{{ user?.firstname[0]?.toUpperCase() + '' + user?.lastname && user?.lastname[0]?.toUpperCase()}}</span>
                    </div>
                    <div class="fw-bold">
                      <span class="fs-6 text-gray-800 me-2">{{user.firstname + ' ' + user.lastname}}</span>
                    </div>
                    <div class="ms-auto">
                      <i class="fa fa-times" @click="removeUser(user.id)"></i>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <Button type="cancel" @click="closeModal" :id="id+'_cancel_btn'" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel"></Button>
              <Button btn-class="btn-sm me-3" type="new" :id="id+'_submit_btn'" btn-text="button.save" size="7px 30px" :is-loading="isLoadingUsers"></Button>
            </div>
            </div>
        </form>
        </div>
  </div>
  <UserFormModal id="create-user-modal" :user="formUserData" @afterCreate="reloadUserDatas" />
</template>

<script setup>
import Card from "@/Modules/CRM/components/Card.vue";
import OutlineButton from "@/components/OutlineButton.vue"
import Button from "@/components/Button.vue"
import ManyAvatar from "@/components/ManyAvatar.vue"
import {computed, onMounted, ref} from "vue";
import i18n from "@/plugins/i18n";
import {useRoute} from "vue-router";
import {useStore} from "vuex";
import Select2 from "@/components/Select2.vue"
import UserFormModal from "@/components/modals/UserForm.vue"
import RequiredText from "@/components/RequiredText.vue"
import abilities from "@/composables/abilities";

const store = useStore()
const route = useRoute()

const secondaryColor = ref('rgba(240, 120, 23, 1)')
const primaryColor = ref('rgba(0, 114, 206, 1)')

const emits = defineEmits(['load', 'loadUsers'])

const props = defineProps({partners: Array, users: Object, pipeline: Object, right: Boolean})

const formUserData = ref({
  gender: '',
  lastname: '',
  firstname: '',
  email: '',
  phone_code: '',
  phone: '',
  role: null,
  active: true,
  department_id: null
})

const isLoadingUsers = ref(false)
const usersIds = ref([])
const getUsersNotFollowers = computed(() => {
  let followersIds = props.partners.map(user => user?.id);
  return props.users.filter(user => !followersIds.includes(user.id) && user.id !== props.pipeline?.creator_id);
})

function closeModal() {
  $('#addUsers').modal('toggle')
}

function openCreateUserModal(){
  $('#create-user-modal').modal('toggle')
}

async function reloadUserDatas() {
  emits('loadUsers')
}

function addUsers(){
    isLoadingUsers.value = true
    store.dispatch('pipelines/addUsersPipeline', {opportunity_id: route.params.id, users: usersIds.value})
    .then(res => {
      emits('load')
      $('#addUsers').modal('toggle')
      window.toastr['success'](i18n.global.t("notification.users_added"))
    })
    .catch((err) => {

    }).finally(() => isLoadingUsers.value = false)
}

function removeUser(id){
  store.dispatch('pipelines/removeUsersPipeline', {opportunity_id: route.params.id, user_id: id})
    .then(res => {
      emits('load')
      window.toastr['success'](i18n.global.t("notification.users_removed"))
    })
    .catch((err) => {

    })
}
function loadDepartments(){
  store.dispatch('department/loadDepartments')
}
function loadRoles(){
  store.dispatch('role/loadRole')
}

onMounted(()=>{
  loadDepartments()
  loadRoles()
})

</script>

<style scoped>
</style>
